import * as React from "react";
import "./ToggleSwitch.scss";

interface IToggleSwitchProps {
    id: string;
    title?: string;
    checked?: boolean;
    defaultChecked?: boolean;
    disabled?: boolean;
    onClick: (checked: boolean) => void;
    infoButton?: JSX.Element;
}

/* use 'checked' only for 'controlled' component, when state is managed by it`s parent  */
/* use 'defaultChecked' only for 'uncontrolled' component, when state is not managed by parent */
/* https://github.com/facebook/react/issues/13477#issuecomment-416003818 */

export const ToggleSwitch = ({
    id,
    title,
    checked,
    defaultChecked,
    disabled,
    onClick,
    infoButton
}: IToggleSwitchProps): JSX.Element => (
    <div className="isolator">
        <div className="list-group-item unselectable">
            <label className="toggle-label" htmlFor={id}>
                {title}
                {infoButton || null}
            </label>
            <div className="pull-right switch">
                {typeof checked === "boolean" ? (
                    <input /* controlled input */
                        type="checkbox"
                        id={id}
                        key={id}
                        checked={checked}
                        onChange={(e) => onClick(e.target.checked)}
                        disabled={disabled}
                        data-testid={id}
                    />
                ) : (
                    <input /* uncontrolled input */
                        type="checkbox"
                        id={id}
                        key={id}
                        defaultChecked={defaultChecked}
                        //@ts-ignore
                        onClick={(e) => onClick(e.target.checked)}
                        disabled={disabled}
                        data-testid={id}
                    />
                )}
                <label htmlFor={id} className="slider round"></label>
            </div>
        </div>
    </div>
);
